export default "__VITE_ASSET__Bkq0FL5S__"